module.exports = __webpack_public_path__ + "static/media/devices.51835428.svg";